<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong >{{$t('requestConfirmer')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form==0" @click="insert_data()" type="submit" size="sm"
                         color="secondary">
                  {{ $t('buttons.save') }}
                </CButton>

<!--                <CButton-->
<!--                    class="mr-1"-->
<!--                    size="sm"-->
<!--                    color="secondary"-->
<!--                >{{ $t("buttons.print") }}-->
<!--                </CButton>-->
              </CCol>
            </CRow>
          </CCardHeader>
<CRow>
  <CCol class="text-center"><CButton @click="active_type=1" :color="get_button_color(1)" size="lg">1 <br>{{$t('unitAdmin')}}</CButton> </CCol>
  <CCol class="text-center"><CButton @click="active_type=2" :color="get_button_color(2)" size="lg">2 <br>{{$t('accountingAdmin')}}</CButton></CCol>
  <CCol class="text-center"><CButton @click="active_type=3" :color="get_button_color(3)" size="lg">3 <br>{{$t('manager')}}</CButton></CCol>
</CRow>
          <CCardBody>
                <CDataTable
                    :items="items_jobs.filter(x=>x.userType == active_type || x.userType==0)"
                    :fields="job_fields"
                    :items-per-page="20"
                    style="z-index: 1000;margin-bottom: 50px"
                >
<!--                  <template #branch="{item,index}">-->

<!--                    <td v-if="index!=0">-->
<!--                      <p >{{ item.branch }}</p>-->

<!--                    </td>-->
<!--                    <td v-else>-->
<!--                      <CSelect-->
<!--                          :options="branch_items"-->
<!--                          :value.sync="selected_branch"-->
<!--                          horizontal-->
<!--                          :disabled="active_type==0"-->
<!--                      />-->

<!--                    </td>-->

<!--                  </template>-->

                  <template #departmentTitle="{item,index}">

                    <td v-if="index!= 0">
                      <p>{{ item.departemanTitle }}</p>

                    </td>
                    <td v-else>
                      <CRow form class="form-group">

                        <CCol sm="9">
                          <CSelect
                              :options="department_items"
                              :value.sync="selected_department"
                              horizontal
                              :disabled="active_type==0"
                          />
                        </CCol>

                      </CRow>

                    </td>

                  </template>

                  <template #unitTitle="{item,index}">

                    <td v-if="index != 0">
                      <p>{{ item.unitTitle }}</p>

                    </td>
                    <td v-else>
                      <CSelect
                          :options="get_department_jobs"
                          horizontal
                          :disabled="active_type==0"
                          :value.sync="selected_job"
                      />
                    </td>


                  </template>

                  <template #userName="{item,index}">

                    <td v-if="index!=0">
                      <p>{{ item.userName }}</p>

                    </td>
                    <td v-else>
                      <treeselect
                              :disabled="active_type==0"
                          v-model="item.user_id"
                          :async="item.user_sync"
                          :load-options="load_persons"
                          :appendToBody="true"
                          :placeholder="$t('search')"
                          @select="select_user"
                          :options="item.user_list"
                          :normalizer="normalizer_persons"
                      />
                    </td>

                  </template>
                  <template #operation="{item,index}">
                    <td v-if="index==0">
                      <CButton
                          color="primary"
                          variant="outline"
                          square
                          :disabled="active_type==0"
                          @click="add_job_item()"
                          size="sm"
                          :title="$t('buttons.add')"
                      >
                        <CIcon size="sm" name="cil-plus"/>
                      </CButton>

                    </td>
                    <td v-else>
                      <CButton class="m-1"
                               color="warning"
                               variant="outline"
                               square
                               @click="job_item_delete(index)"
                               size="sm"
                               :title="$t('buttons.delete')"
                      >
                        <CIcon name="cil-minus"/>
                      </CButton>
                      <!--                      <CButton class="m-1"-->
                      <!--                               color="warning"-->
                      <!--                               variant="outline"-->
                      <!--                               square-->
                      <!--                               @click="job_item_edit(item,index)"-->
                      <!--                               size="sm"-->
                      <!--                               :title="$t('buttons.edit')"-->
                      <!--                      >-->
                      <!--                        <CIcon name="cil-pencil"/>-->
                      <!--                      </CButton>-->

                    </td>
                  </template>

                </CDataTable>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import moment from 'moment-jalaali'
import Vue from "vue";
import BTabs from "../../tabs/BTabs";
var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'Login',
  components: {
    BTabs,
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      job_fields: [
        // {key: 'branch', label: this.$t('tables.branch'), _style: 'width:10%'},
        {key: 'departmentTitle', label: this.$t('components.department'), _style: 'width:10%;text-align:center'},
        {key: 'unitTitle', label: this.$t('tables.unit'), _style: 'width:10%;text-align:center'},
        {key: 'userName', label: this.$t('ConfirmerName'), _style: 'width:10%;text-align:center'},
        {key: 'operation', label: "", _style: 'width:10%'},
      ],

      selected_status: 0,
      branch_items: [],
      job_items: [],
active_type:0,
      selected_branch: 0,
      selected_job: 0,
      department_items: [],
      selected_department: null,
      department_all_job_titles: [],
      normalizer_department(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,

        }
      },

      details: [],
      items_jobs: [{row_id: '0', name: '', departmentTitle: '', unitTitle: '', user_sync: true, branch: '',userType:0}],

      status_form: 0,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  },
  mounted() {
    this.$root.root_validate_errors = [];

   this.get_jobs();
   this.get_data();
    this.get_branches();
    this.get_departments();



  },
  computed: {
    get_department_jobs() {
      if (this.get_childrens(this.selected_department, this.department_all_job_titles).length) {


        this.selected_job = this.get_childrens(this.selected_department, this.department_all_job_titles)[0].value
        return this.get_childrens(this.selected_department, this.department_all_job_titles)
      }
    },
  },
  watch: {

    'selected_branch': function () {
      this.get_departments();
    }
  },
  methods: {

get_button_color(type){
  if(this.active_type==type){
    return "success"
  }else{
    return "dark"
  }

},
    select_user(node) {
      this.items_jobs[0].userName = node.userName+ " "+node.surName;
    },

    add_job_item() {
  if(this.items_jobs.filter(x=>x.user_id == this.items_jobs[0].user_id).length>1){
    this.$root.modal_component.show_validate_errors(["کاربر تکراری میباشد"])
    return false;
  }
  // console.log('department items',this.department_items,this.selected_department)
      // console.log(this.job_items, this.selected_job)
      var item = {
        name: '',
        departemanTitle: this.department_items.filter(z => z.value == this.selected_department)[0].label,
        department_id: this.selected_department,
        unitTitle: this.get_department_jobs.filter(z => z.value == this.selected_job)[0].label,
        title_id: this.selected_job,
        userName: this.items_jobs[0].userName,
        user_id: this.items_jobs[0].user_id,
        userType: this.active_type
        // branch: this.branch_items.find(z => z.value === this.selected_branch).label,
        // branch_id: this.selected_branch,
      }
      if (this.items_jobs.length == 1) {
        item.default = true;
      }
      this.items_jobs.push(item)
    },
    job_item_edit(item, index) {
      // var item = [];
// this.items[0] = item;
      console.log("edit item");
      Vue.set(this.items_jobs, 0, item)
    },
    job_item_delete(index) {
      this.items_jobs.splice(index, 1);
    },
    get_departments() {
      var self = this;

      const formData = new FormData();

      formData.append('BranchId', this.selected_branch);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.department_items = []

          self.department_all_job_titles = response.data.data.filter(x=> x.recType==0);
          var departments = response.data.data;
          // departments = departments.filter(item => item.recType == 0);
          departments = departments.filter(x=> x.recType==0);

          departments.forEach((val) => {
            if (val.parentId == 0) {

            var obj = {
              "label": val.title,

              parentId: val.parentId,
              value: val.id,
              recType: val.recType,
              image_url: '/img/avatars/custom.png',

              // "selected":true,
              // children: self.get_department_childrens(val.id, response.data.data),
              // mate: self.get_mates(val.id, response.data.data)
            }
            self.department_items.push(obj);
            }

          });
          self.selected_department = self.department_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_department_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            name: val2.title,
            id: val2.id,
            children: this.get_department_childrens(val2.id, list),
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,

            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);

          // val2.inserted = true;

        }

      });
      if (array.length) {
        return array;

      } else {
        return null;

      }

    },
    get_department_mates(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 1) {
          var obj = {
            label: val2.title,
            value: val2.id,
            children: this.get_department_childrens(val2.id, list),
            mate: this.get_department_mates(val2.id, list),
            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);
          // val2.inserted = true;

        }
      });

      if (array.length) {
        return array;

      } else {
        return null;

      }
    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
              self.branch_items, content_data.data,
              'branchId','branchTitle');

          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_jobs() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      formData.append('RecType', 0);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;
        self.job_items= [];
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var jobs = content_data.data;
          jobs = jobs.filter(item => item.recType == 0);
          jobs.forEach((val) => {
            if(val.parentId == 0){
              var obj = {label: val.title, value: val.id}

              self.job_items.push(obj);
            }
          });
          if (self.job_items.length)
            self.selected_job = self.job_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            label: val2.title,
            value: val2.id,
            // children: this.get_childrens(val2.id, list),
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,
            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',
          }
          array.push(obj);

        }

      });
      // if (array.length) {
        return array;

      // } else {
      //   return null;

      // }

    },

    insert_data() {
  var self = this;

var details = [];
      var obj_send={Details:details};
      this.items_jobs.forEach((val) => {
      if(val.userType!=0) {
        var obj = {
          DepartemanId: val.department_id,
          UnitId: val.title_id,
          UserId: val.user_id,
          UserName: val.userName,
          UserType: val.userType,
        };
        if (val.userType == 1) {
          obj.UserTypeTitle = this.$t('unitAdmin');
        }
        if (val.userType == 2) {
          obj.UserTypeTitle = this.$t('accountingAdmin');
        }
        if (val.userType == 3) {
          obj.UserTypeTitle = this.$t('manager');
        }
        details.push(obj);
      }
      });

      const formData = new FormData();
      let url = "AddSystemRequestUsers";

      formData.append('input', JSON.stringify(details));

      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {

            self.get_data()


        } else {

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_data() {

      // GetSystemRequestUsers => UserType
      // AddSystemRequestUsers
      //
      // DepartemanId
      // UnitId
      // UserId
      // UserName
      // UserType
      // UserTypeTitle
      //         DepartemanId
      // UnitId
      // UserType => 1 مدیریت واحد
      // 2 مدیریت مالی
      // 3 مدیریت
      //
      // UserTypeTitle

      let self = this;
      const formData = new FormData();
      let url = "GetSystemRequestUsers";


      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        // self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {

          self.items_jobs=  res.data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_jobs.splice(0,0,{row_id: '0', userName: '', departmentTitle: '', unitTitle: '', user_sync: true, branch: '',userType:0})
        } else {

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
  }
}

</script>
